import React, { useContext } from 'react';
import styled from 'styled-components';
import { Footer } from '@/features/editor/widgets/shared/modals/commons';
import { LayeredRulingContext } from '@/features/editor/widgets/custom-widget/loading-section/layered-ruling/context';
import {
  RecommendationOptions,
  RecommendationType,
} from '@/webapi/use-widget-catalog-api';
import { CustomWidgetContext } from '@/features/editor/widgets/custom-widget/shared/context';
import { UndoRedoBtns } from '@/components/undo-redo-btns';

type Props = { close: () => void };

export function ModalFooter({ close }: Props) {
  const ctx = useContext(LayeredRulingContext);
  const { updateRecommendationOptions } = useContext(CustomWidgetContext);
  const onClick = () => {
    if (ctx.state.showCondBuilder) {
      ctx.toggleCondBuilder();
      return;
    }
    if (ctx.isGlobalFilterOpen) {
      ctx.setIsGlobalFilterOpen(false);
      ctx.saveGlobalFilter();
      return;
    }
    updateRecommendationOptions({
      type: RecommendationType.ADVANCED_RULING,
      layeredRuling: ctx.state.rules,
      strategyPerSlot: undefined,
      advancedRuling: undefined,
      condition: undefined,
      manualProducts: undefined,
      productIds: undefined,
    } as RecommendationOptions);
    close();
  };
  let text = `Save`;
  if (ctx.state.showCondBuilder) {
    text = `Continue`;
  }
  if (ctx.isProductSearchOpen || ctx.isManualImageSelectionOpen) {
    return null;
  }
  const deleteGlobal = () => {
    ctx.setIsGlobalFilterOpen(false);
    ctx.deleteGlobalFilter();
  };
  return (
    <Wrapper>
      <UndoRedoBtns
        undo={ctx.undo}
        redo={ctx.redo}
        canUndo={ctx.canUndo}
        canRedo={ctx.canRedo}
        debounceInterval={500}
      />
      {ctx.isGlobalFilterApplied && ctx.isGlobalFilterOpen && (
        <Footer
          classNames="delete-global"
          onClick={deleteGlobal}
          bg="white"
          color="black"
          size="xl"
          text="Delete"
        />
      )}
      <Footer onClick={onClick} bg="black" size="xl" text={text} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: auto auto auto;

  && > .delete-global {
    border: 2px black solid;
  }
`;
